import { gql } from '@apollo/client'

export const GET_PLAN_LOCATIONS = gql`
  query GetPlanLocations {
    planLocations {
      plan_location_id
      place
      longitude
      latitude
    }
  }
`

export const GET_GPS_FOR_ADDRESS = gql`
  query GetGPSForAddress($location_id: String) {
    GPSForAddress(location_id: $location_id) {
      latitude
      longitude
      found
    }
  }
`

export const GET_LOCATIONS = gql`
  query GetLocations {
    locations {
      location_id
      location_data_id
      place
      street
      country_code
      postal
      city
    }
  }
`
